import { useParams } from 'react-router';
import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../components/settings';
import CustomBreadcrumbs from '../../components/custom-breadcrumbs';
import { PATH_DASHBOARD } from '../../routes/paths';
import { useLocales } from '../../locales';
import TourBundleEditForm from '../../sections/@dashboard/tour-bundle/TourBundleEditForm';
import { selectTourBundleById, useGetTourBundlesQuery } from '../../redux/slices/tourSlice';
import { useAppSelector } from '../../hooks/app';

export default function TourBundleDetail() {
  const { translate } = useLocales();
  const { themeStretch } = useSettingsContext();
  const { id = '' } = useParams();
  const isEdit = !!id;

  useGetTourBundlesQuery();
  const currentTourBundle = useAppSelector((state) => selectTourBundleById(state, id));

  return (
    <>
      <Helmet>
        <title>{`${translate('tourBundle.bundleName')}`}</title>
      </Helmet>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading={`${translate('tourBundle.bundleName')}`}
          links={[
            { name: `${translate('dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('tourBundle.bundleName')}`,
              href: PATH_DASHBOARD.basicSetting.tourBundle.list,
            },
            {
              name: currentTourBundle ? currentTourBundle.name : `${translate('tourBundle.new')}`,
            },
          ]}
        />
        <TourBundleEditForm isEdit={isEdit} currentId={id} />
      </Container>
    </>
  );
}
